const translations = {
    IsRequired: 'Đây là thông tin bắt buộc',
    PleaseEnterValidEmail: 'Vui lòng nhập email đúng định dạng',
    PleaseEnterValidPhone: 'Vui lòng nhập số điện thoại đúng định dạng',
    SelectLocation: 'Chọn tỉnh/thành theo khu vực',
    SelectCity: 'Chọn tỉnh/ thành phố',
    SelectDistrict: 'Chọn quận/ huyện',
    Address: 'Địa chỉ',
    Phone: 'Điện thoại',
    WorkHours: 'Giờ mở cửa',
    ShowMap: 'Tìm đường',
    NoStore: 'Không có cửa hàng',
};

export { translations as t };
